import { defineMessages } from 'react-intl';

export default defineMessages({
  rovoDevAgentsPageTitle: {
    id: 'frontbucket.workspace.settings.code-reviewer-page-title',
    description:
      'Title shown at the top of the workspace settings page for Rovo Dev Agents',
    defaultMessage: 'Rovo Dev Agents',
  },
  codeReviewerPageDescription: {
    id: 'frontbucket.workspace.settings.code-reviewer-page-description',
    description:
      'Description shown underneath the workspace settings page title for Rovo Dev Agents',
    defaultMessage:
      'The Rovo Dev Agents available in Bitbucket are Code Reviewer, Pipeline Troubleshooter, and Deployment Summarizer. {readMoreLink}',
  },
  readAboutRovoDevAgents: {
    id: 'frontbucket.workspace.settings.read-about-rovo-dev-agents',
    description: 'Text to go on a link for Rovo Dev Agents',
    defaultMessage: 'Read about Rovo Dev Agents.',
  },
  codeReviewerIsEnabled: {
    id: 'frontbucket.workspace.settings.code-reviewer-is-enabled',
    description:
      'Message that displays if Code Reviewer is enabled for this workspace',
    defaultMessage: 'Code Reviewer is currently enabled in this workspace',
  },
  codeReviewerIsDisabled: {
    id: 'frontbucket.workspace.settings.code-reviewer-is-disabled',
    description:
      'Message that displays if Code Reviewer is disabled for this workspace',
    defaultMessage: 'Code Reviewer is currently disabled in this workspace',
  },
  codeReviewerThingsYouShouldKnowDeactivation: {
    id: 'frontbucket.workspace.settings.code-reviewer-things-you-should-know-deactivation',
    description: 'Deactivation thing you should know',
    defaultMessage:
      'You can deactivate Code Reviewer for a product or repository at any time.',
  },
  codeReviewerTermsOfService: {
    id: 'frontbucket.workspace.settings.code-reviewer-terms-of-service',
    description:
      'Label shown next to the checkbox encouraging users to agree to the terms of service',
    defaultMessage:
      'By activating, you agree to the {codeReviewerTerms}. (required)',
  },
  codeReviewerToggleLabel: {
    id: 'frontbucket.workspace.settings.code-reviewer-toggle-label',
    description: 'Label for workspace level Code Reviewer toggle',
    defaultMessage: 'Use Rovo Dev Agents in this workspace',
  },
  workspaceToggleTooltipText: {
    id: 'frontbucket.workspace.settings.workspace-toggle-tooltip-text',
    description:
      'Tooltip that shows next to the label for workspace level code reviewer toggle',
    defaultMessage:
      'When this setting is enabled, all users in this workspace can use Rovo Dev Agents. Code Reviewer must be enabled on each repository.',
  },
  codeReviewerTermsOfServiceLinkLabel: {
    id: 'frontbucket.workspace.settings.code-reviewer-terms-of-service-link-label',
    description: 'Text shown on the link to the Atlassian Terms of Service',
    defaultMessage: 'Code Reviewer Terms',
  },
  permissionsError: {
    id: 'frontbucket.workspace.settings.rovo-dev-agents-permissions-error',
    description:
      "Error shown when some of the requirements can't fail to get checked when viewing rovo dev agents page",
    defaultMessage:
      'Something went wrong and we couldn’t load this page, reload it to try again.',
  },
  enableAtReposAfterWorkspaceBanner: {
    id: 'frontbucket.workspace.settings.enable-at-repos-after-workspace-banner',
    description: 'Banner shown when enabling Code Reviewer at a workspace',
    defaultMessage:
      'To use Code Reviewer, it must also be enabled on each repository you want it to monitor. To do this, go to Repository settings, then Code Reviewer.',
  },
  agreeToTermsOfServiceError: {
    id: 'frontbucket.workspace.settings.code-reviewer-agree-to-terms-of-service-error',
    description:
      'Error shown when you attempt to activate Code Reviewer on the workspace without accepting the Terms of Service',
    defaultMessage:
      'You must accept the Code Reviewer specific terms to activate Code Reviewer.',
  },
  rovoDevAgentsEmptyHeader: {
    id: 'frontbucket.workspace.settings.rovo-dev-agents-empty-header',
    description:
      'Text shown on the header for the empty state page on the rovo dev agents page.',
    defaultMessage: "Rovo Dev Agents isn't available in this workspace",
  },
  toUseRovoDevAgentsYouNeed: {
    id: 'frontbucket.workspace.settings.to-use-rovo-dev-agents-you-need',
    description:
      'Text shown underneath the heading on the empty state page on the rovo dev agents page',
    defaultMessage: 'To use Rovo Dev Agents, you need:',
  },
  enabledRDAFlagTitle: {
    id: 'frontbucket.workspace.settings.enabled-flag-title',
    description:
      'Title of the flag that shows when you enable Rovo Dev Agents from the workspace',
    defaultMessage: 'Rovo Dev Agents Enabled',
  },
  disabledRDAFlagTitle: {
    id: 'frontbucket.workspace.settings.disabled-flag-title',
    description:
      'Title of the flag that shows when you disable Rovo Dev Agents from the workspace',
    defaultMessage: 'Rovo Dev Agents Disabled',
  },
  setupCodeReviewer: {
    id: 'frontbucket.workspace.settings.setup-code-reviewer',
    description: 'Heading for the setting up code reviewer',
    defaultMessage: 'Set up Code Reviewer',
  },
  usingCodeReviewer: {
    id: 'frontbucket.workspace.settings.using-code-reviewer',
    description: 'Heading for using code reviewer',
    defaultMessage: 'Using Code Reviewer',
  },
  thingsToKnowAboutCodeReviewer: {
    id: 'frontbucket.workspace.settings.things-to-know-about-code-reviewer',
    description: 'Text above the list of things to know about code reviewer',
    defaultMessage:
      'Here are some key things to know about Code Reviewer. {readMoreLink}',
  },
  readAboutCodeReviewer: {
    id: 'frontbucket.workspace.settings.read-about-code-reviewer',
    description:
      'Text to go on a link in the text above the list of things to konw about code reviewer',
    defaultMessage: 'Read more about using Code Reviewer',
  },
  thingToKnowOne: {
    id: 'frontbucket.workspace.settings.things-to-know-one',
    description: 'First item on the list of things to know about Code Reviewer',
    defaultMessage:
      'Code Reviewer can review around 10 pull requests per hour in this workspace (depending on system resources). If you go over the limit, the agent will stop reviewing pull requests for about an hour.',
  },
  thingToKnowTwo: {
    id: 'frontbucket.workspace.settings.things-to-know-two',
    description:
      'Second item on the list of things to know about Code Reviewer',
    defaultMessage:
      'We currently support 10 popular languages, including Java, Javascript, Python, C++, and Go. {viewFullList}',
  },
  viewFullListOfLanguages: {
    id: 'frontbucket.workspace.settings.view-full-list-of-languages',
    description:
      'Text to go on a link for the full list of languages supported by Code Reviewer',
    defaultMessage: 'View the full list of supported languages',
  },
});
